import { TAREFA_STATUS_COLOR_MAP } from "@/constants/statusColors";
import { TarefaStatusMap, TarefaStatus } from "@workflow/types";
import { cn } from "@/lib/utils";
import { StatusBadge } from "../ui/badge-status";

interface TarefaStatusBadgeProps {
  status: TarefaStatus;
  className?: string;
}

export function TarefaStatusBadge({ status, className }: Readonly<TarefaStatusBadgeProps>) {
  const text = TarefaStatusMap[status] || status;
  const colorClass = TAREFA_STATUS_COLOR_MAP[status] || TAREFA_STATUS_COLOR_MAP.PENDENTE;

  return (
    <StatusBadge color={colorClass} className={cn(className)}>
      {text}
    </StatusBadge>
  );
}
